import { Fragment } from "react"

const PHRASE_GROUPS: Readonly<Record<string, readonly string[]>> = {
  "흩어진 리워드를 한곳에서 더 분명하게": ["흩어진 리워드를", "한곳에서 더 분명하게"],
  "포인트의 이동을 이해하기 쉽게": ["포인트의 이동을", "이해하기 쉽게"],
  "처음이어도 네 단계면 충분합니다": ["처음이어도", "네 단계면 충분합니다"],
  "정책은 승인된 버전으로만 공개합니다": ["정책은 승인된", "버전으로만 공개합니다"],
  "함께 더 나은 리워드 경험을 만듭니다": ["함께 더 나은", "리워드 경험을 만듭니다"],
  "궁금한 점을 빠르게 해결해 드려요": ["궁금한 점을", "빠르게 해결해 드려요"],
  "민감정보 없이 안전하게 도움받기": ["민감정보 없이", "안전하게 도움받기"],
  "전환·통합잔액 운영정책": ["전환·통합잔액", "운영정책"],
  "계정 삭제는 본인 확인 후 안전하게": ["계정 삭제는", "본인 확인 후 안전하게"],
  "공개 페이지에서 개인정보를 입력하지 않고, 로그인된 CashHub 경로에서 잔액과 진행 거래를 먼저 확인합니다.": ["공개 페이지에서", "개인정보를 입력하지 않고,", "로그인된 CashHub 경로에서", "잔액과 진행 거래를", "먼저 확인합니다."],
  "현재 기기에 맞는 안전한 시작": ["현재 기기에 맞는", "안전한 시작"],
  "첫 공개 웹 서비스 준비 안내": ["첫 공개 웹 서비스", "준비 안내"],
  "정책 문서 게시 원칙 안내": ["정책 문서", "게시 원칙 안내"],
  "복잡한 이동은 안쪽에서, 이해는 바깥에서": ["복잡한 이동은 안쪽에서,", "이해는 바깥에서"],
  "알 수 없는 결과를 성공이나 실패로 단정하지 않습니다": ["알 수 없는 결과를", "성공이나 실패로", "단정하지 않습니다"],
  "포인트를 더 분명하게 시작하세요": ["포인트를 더 분명하게", "시작하세요"],
  "CashHub 안에서 임의로 포인트를 조회하지 않고, 이용 중인 제휴 서비스의 안전한 진입점에서 시작합니다.": ["CashHub 안에서 임의로", "포인트를 조회하지 않고,", "이용 중인 제휴 서비스의", "안전한 진입점에서 시작합니다."],
  "법무 승인 전인 약관은 공개 문서로 사용할 수 없습니다.": ["법무 승인 전인 약관은", "공개 문서로 사용할 수 없습니다."],
  "법무와 개인정보 담당자의 승인 전인 문서는 공개할 수 없습니다.": ["법무와 개인정보 담당자의", "승인 전인 문서는", "공개할 수 없습니다."],
  "법적 성격과 운영 기준이 승인되기 전에는 본문을 게시하지 않습니다.": ["법적 성격과 운영 기준이", "승인되기 전에는", "본문을 게시하지 않습니다."],
  "포인트의 이동을 쉽고 안전하게 이해할 수 있도록 돕습니다.": ["포인트의 이동을", "쉽고 안전하게", "이해할 수 있도록 돕습니다."],
} as const

type PhraseTextProps = {
  readonly phrases?: readonly string[]
  readonly text: string
}

export const PhraseText = ({ phrases, text }: PhraseTextProps) => {
  const segments = phrases ?? PHRASE_GROUPS[text]
  if (segments === undefined) return text
  return segments.map((phrase, index) => (
    <Fragment key={phrase}>
      <span className="phrase-safe" data-phrase-safe>
        {phrase}
      </span>
      {index === segments.length - 1 ? null : " "}
    </Fragment>
  ))
}
